export const GET_AUTH_PROVIDER_DETAILS = 'GET_AUTH_PROVIDER_DETAILS';
export const GET_AUTH_PROVIDER_URL = 'GET_AUTH_PROVIDER_URL';
export const GET_AUTH_PROVIDER_URL_SUCCESS = 'GET_AUTH_PROVIDER_URL_SUCCESS';
export const GET_AUTH_PROVIDER_URL_FAILURE = 'GET_AUTH_PROVIDER_URL_FAILURE';

export const SEND_EXTERNAL_AUTH_TOKEN = 'SEND_EXTERNAL_AUTH_TOKEN';
export const SEND_EXTERNAL_AUTH_TOKEN_SUCCESS =
  'SEND_EXTERNAL_AUTH_TOKEN_SUCCESS';



// WEBPACK FOOTER //
// ./src/actionTypes/oauthActionTypes.js